import React, { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import csvDownload from "json-to-csv-export";
import BarChart from "../Home/BarChart";
import ReportsServices from "../../services/ReportsServices";
import moment from "moment";

function CurrentMonthOrder() {
  const [reportData, setReportData] = useState([]);

  const { RangePicker } = DatePicker;
  const currentDate = new Date();
  const last12MonthsStartDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 11,
    1
  ).toISOString();
  const last12MonthsEndDate = currentDate.toISOString();
  const [startDateClick, setStartDateClick] = useState(last12MonthsStartDate);
  const [endDateClick, setEndDateClick] = useState(last12MonthsEndDate);

  const getCurrentReport = useCallback(() => {
    ReportsServices.currentMonthOrder(startDateClick, endDateClick)
      .then((res) => {
        // Reverse the order of the months in the table array
        const reversedTable = res[2]?.table?.reverse();
        setReportData([res[0], res[1], { table: reversedTable }]);
      })
      .catch((err) => console.log(err.message));
  }, [startDateClick, endDateClick]);

  const handleCalendarChange = (value, dateString) => {
    if (dateString[0] === "" && dateString[1] === "") {
      setStartDateClick(last12MonthsStartDate);
      setEndDateClick(last12MonthsEndDate);
    } else {
      setStartDateClick(dateString[0]);
      setEndDateClick(dateString[1]);
    }
  };

  useEffect(() => {
    getCurrentReport();
  }, [getCurrentReport]);

  const handleClearDateRange = () => {
    // Handle the case when the date range is cleared
  };

  const dataToConvert = {
    data: reportData[2]?.table,
    filename: "Monthly_Orders_Trend",
    delimiter: ",",
    headers: ["Month", "Orders"],
  };

  return (
    <>
      <Helmet>
        <title>Reports - Emberace</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">
                    Monthly Orders Trend - Last 12 Comparison
                  </h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Reports</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4"></div>
              <div className="col-md-8">
                <div className="float-end">
                  <div className=" mb-3">
                    <RangePicker
                      allowClear="true"
                      onCalendarChange={handleCalendarChange}
                    />
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card" style={{ borderRadius: "15px" }}>
                  <div className="card-body">
                    <BarChart reportData={reportData} />
                    {/* <LineChart OrderData={OrderData} /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="float-end pb-2">
                        <Link
                          onClick={() => csvDownload(dataToConvert)}
                          to="#"
                          className=""
                        >
                          <p style={{ textDecorationLine: "underline" }}>
                            Export csv
                          </p>
                        </Link>
                      </div>
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th>Month</th>
                            <th>Total Orders</th>
                            <th>Pending</th>
                            <th>Processing</th>
                            <th>Delivered</th>
                            <th>Cancelled</th>
                            <th>Returned</th>
                            <th>Dispatched</th>
                          </tr>
                        </thead>

                        <tbody>
                          {reportData[2]?.table?.map((item, i) => (
                            <>
                              <tr key={i}>
                                <td>{item.month}</td>
                                <td>{item.orders}</td>
                                <td>{item.Pending || 0}</td>
                                <td>{item["In Process"] || 0}</td>
                                <td>{item.Delivered || 0}</td>
                                <td>{item.Cancelled || 0}</td>
                                <td>{item.Returned || 0}</td>
                                <td>{item.Dispatched || 0}</td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CurrentMonthOrder;
